<template>
  <q-card flat>
    <q-card-section class="no-padding fixed-header-position">
      <q-banner class="bg-blue text-white" inline-actions>
        بانک اطلاعاتی رانندگان
        <template v-slot:action>
          <q-btn @click="driverInfoDialog=true" round icon="add" color="red">
            <q-tooltip>
              معرفی راننده جدید
            </q-tooltip>
          </q-btn>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <DriverItems :items="items" @driver-updated="driverUpdated"/>
    </q-card-section>

    <q-dialog v-model="driverInfoDialog">
      <DriverInfo :driver-info="null" @driver-added="driverAdded"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import DriverItems from "@/components/Driver/DriverItems";
import DriverInfo from "@/components/Driver/DriverInfo";

export default {
  name: "DriverList",
  components: {DriverInfo, DriverItems},
  data() {
    return {
      items: [],
      driverInfoDialog: false
    }
  },
  methods: {
    ...mapActions({
      getVisitorList: 'Orders/getDriverList'
    }),
    driverAdded(arg) {
      this.items.unshift(arg)
      this.$q.notify({
        type: 'positive',
        color: 'positive',
        position: 'top',
        message: 'اطلاعات راننده ثبت گردید'
      })
      this.driverInfoDialog = false
    },
    driverUpdated(args) {
      let driver = this.items.filter(item=> item.Visitor_Tel=== args.Visitor_Tel)
      if (driver.length>0){
        driver[0].Visitor_Name = args.Visitor_Name
        driver[0].Visitor_NumCar = args.Visitor_NumCar
        this.$q.notify({
          type: 'positive',
          color: 'positive',
          position: 'top',
          message: 'اطلاعات راننده به روز رسانی گردید'
        })
      }
    },
    loadData() {
      this.getVisitorList().then((res) => {
        this.items = res
      })
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped>
.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000;
}
</style>